// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"delta-pro-portable-power-station_productcontent__tTmW7"};